import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import VideosCarousel from "../VideosCarousel";
import Top10Videos from "../Top10Videos";

const LastVideos = () => {
  return (
    <Box py={[8, 10]} px={[4, 6, 8]} maxW="1400px" mx="auto">
      <Heading
        fontSize={["1.6rem", "2rem"]}
        color="green.700"
        mb={1}
        borderLeft="4px solid"
        borderColor="green.400"
        pl={4}
      >
        Vídeos em Destaque
      </Heading>
      <Text color="gray.500" pl={4} mb={8} fontSize="1rem">
        Palestras e conteúdos exclusivos da Jornada Maçônica
      </Text>
      <Flex
        alignItems="flex-start"
        flexDir={["column", "column", "row"]}
        gap={8}
      >
        <Box
          w={["100%", "100%", "62%"]}
          borderRadius="1.25rem"
          overflow="hidden"
          boxShadow="0 4px 24px rgba(0,0,0,0.10)"
        >
          <VideosCarousel />
        </Box>
        <Box w={["100%", "100%", "38%"]} alignSelf="center">
          <Top10Videos />
        </Box>
      </Flex>
    </Box>
  );
};
export default LastVideos;
